export enum ELocalStorage {
    USER = 'USER',
    AM_AUTH = 'AM_AUTH',
    DEFAULT_AM_AUTH = 'DEFAULT_AM_AUTH',
}
